import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { City } from "@emblem/common";
import { ComputedRef, inject, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselBackground',
  setup(__props) {

const city = inject<ComputedRef<City>>("city")!;
const backgrounds = JSON.parse(process.env.BACKGROUND_IMAGES);
const images = ref<string[]>([]);

const backgroundDir =
  city.value && city.value in backgrounds ? city.value : City.GRENOBLE;

const firstImageLoaded = ref(false);

const filenames = backgrounds[backgroundDir];
filenames.sort(() => Math.random() - 0.5);

filenames.forEach((filename: string) => {
  import("../../resources/backgrounds/" + backgroundDir + "/" + filename).then(
    (image) => {
      images.value.push(image.default);
      if (!firstImageLoaded.value) {
        firstImageLoaded.value = true;
      }
    }
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!

  return (firstImageLoaded.value)
    ? (_openBlock(), _createBlock(_component_v_carousel, {
        key: 0,
        id: "carousel-background",
        "show-arrows": false,
        "hide-delimiters": "",
        height: "100%",
        cycle: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (img, i) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, {
              key: i,
              src: img,
              cover: ""
            }, null, 8, ["src"]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})